var _style, _path, _path2, _path3, _rect, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvocadoOil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#EF9062;}\n\t.st2{fill:#F0C15E;}\n\t.st3{fill:#F8EEE1;}\n\t.st4{fill:#B1CF68;stroke:#9FC764;stroke-width:2.2374;stroke-miterlimit:10;}\n\t.st5{fill:#006831;stroke:#006831;stroke-width:1.6781;stroke-miterlimit:10;}\n\t.st6{fill:#9C6D5E;}\n\t.st7{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,151.26,62.06,185.55,104.75,185.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.06,53.83H93.34c-0.67,0-1.29,0.24-1.69,0.65c-3.61,3.73,3.74,10.62,5.26,11.96 c0.4,0.36,0.98,0.56,1.59,0.56h12.4c0.61,0,1.19-0.2,1.59-0.56c1.51-1.34,8.87-8.23,5.26-11.96 C117.35,54.07,116.72,53.83,116.06,53.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.7,85.5c1.98,0.84,3.6,2.94,3.6,4.67v68.99c0,1.73-1.85,3.15-4.11,3.15H84.22c-2.26,0-4.11-1.42-4.11-3.15 V90.18c0-1.73,1.62-3.83,3.6-4.67l7.69-3.25c1.98-0.84,3.6-2.94,3.6-4.67v0.2c0-1.73-1.48-3.15-3.29-3.15s-3.29-1.42-3.29-3.15v-4.6 c0-1.73,1.85-3.15,4.11-3.15h24.39c2.26,0,4.11,1.42,4.11,3.15v4.6c0,1.73-1.48,3.15-3.29,3.15s-3.29,1.42-3.29,3.15v-0.2 c0,1.73,1.62,3.83,3.6,4.67L125.7,85.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.16,
    y: 95.28,
    className: "st3",
    width: 41.08,
    height: 62.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.86,102.84c-8.4-1-18.31,19.98-19.31,28.38c-1,8.4,5,16.02,13.4,17.02c8.4,1,16.02-5,17.02-13.4 C119.97,126.44,116.26,103.84,107.86,102.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.98,101.84c-9.3-1.11-19.38,20.45-20.43,29.26c-1.06,8.94,5.34,17.08,14.28,18.14 c8.94,1.06,17.08-5.34,18.14-14.28C120.93,126.92,117.52,102.97,107.98,101.84z M117.97,134.72c-0.93,7.83-8.06,13.45-15.89,12.52 c-7.83-0.93-13.45-8.06-12.51-15.9c0.95-7.96,10.63-28.39,18.18-27.5C115.22,104.73,118.92,126.71,117.97,134.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105.37,122.35c-3.68-0.44-7.3,4.48-7.85,9.11c-0.55,4.63,2.17,7.21,5.85,7.65c3.68,0.44,6.93-1.44,7.48-6.07 C111.41,128.42,109.05,122.78,105.37,122.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105.49,121.34c-3.62-0.43-8.23,3.75-8.97,10c-0.57,4.77,2.08,8.22,6.74,8.77c4.66,0.55,8.04-2.17,8.61-6.95 C112.61,126.92,109.11,121.77,105.49,121.34z M109.86,132.93c-0.44,3.67-2.81,5.6-6.36,5.18c-3.55-0.42-5.41-2.86-4.97-6.53 c0.48-4.01,3.67-8.59,6.72-8.23C108.3,123.71,110.33,128.92,109.86,132.93z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105,110.7c-0.02-1.45,0.6-2.9,1.67-3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvocadoOil);
export default __webpack_public_path__ + "static/media/Avocado_oil.66ec3c4ceecffdc8c84eab24d7e2b35e.svg";
export { ForwardRef as ReactComponent };